import { render, staticRenderFns } from "./productosMasSolicitados.vue?vue&type=template&id=3d428b49&"
import script from "./productosMasSolicitados.vue?vue&type=script&lang=js&"
export * from "./productosMasSolicitados.vue?vue&type=script&lang=js&"
import style0 from "./productosMasSolicitados.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports